document.addEventListener('livewire:navigated', function () {
    function initializeHistogram() {
        'use strict';

        function updateHistogram(values, items) {
            $(items).each(function (index, item) {
                let value = $(item).data('price');

                if (value >= values[0] && value <= values[1]) {
                    $(item).addClass('active');
                } else {
                    $(item).removeClass('active');
                }
            });
        }

        $(document).off('updateHistogram.histogram').on('updateHistogram.histogram', function (e, values, items) {
            updateHistogram(values, items);
        });
    }

    initializeHistogram();
});
